const gallery = [
  {
    id: 1,
    title: "Ciudad Prohibida",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594603/1_kjzbax.png",
    date: "15/03/2023",
  },
  {
    id: 2,
    title: "Muralla China - Inivierno",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594603/2_u1zlbt.png",
    date: "22/04/2023",
  },
  {
    id: 3,
    title: "Muralla China - Invierno",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594602/3_tayjvd.png",
    date: "05/05/2023",
  },
  {
    id: 4,
    title: "Ciudad Prohibida - Pedida de mano",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594603/4_kxkidm.png",
    date: "05/05/2023",
  },
  {
    id: 5,
    title: "Templo del Cielo",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594603/5_eeiwd6.png",
    date: "05/05/2023",
  },
  {
    id: 6,
    title: "Gran Muralla China - España",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594608/6_xqygny.png",
    date: "05/05/2023",
  },
  {
    id: 7,
    title: "Gran Muralla China - Perú",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594608/7_ifa36q.png",
    date: "05/05/2023",
  },
  {
    id: 8,
    title: "Cidad Prohibida",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594606/8_zy7lvb.png",
    date: "05/05/2023",
  },
  {
    id: 9,
    title: "Gran Muralla China - Mexico",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594608/9_zrno4j.png",
    date: "05/05/2023",
  },
  {
    id: 10,
    title: "Ciudad Prohibida",
    image:
      "https://res.cloudinary.com/ddx3pzjlm/image/upload/v1751594610/10_dvb81q.png",
    date: "05/05/2023",
  },
];

export default gallery;
